// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import LabeledLink from '../../../product/shared/components/labeled-link';
import LabeledString from '../../../shared/components/labeled-string';
import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import {buildDate} from '../../../shared/services/build-date';
import {buildDealer} from '../../../shared/services/build-dealer';
import {buildPartReturnString} from '../../../shared/services/build-part-return-string';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';

const RequestInformationPanel = props =>
    <div>
        {props.partReturn.rgaNumber &&
            <section className='request-information-panel'>
                <LabeledString
                    data={buildDealer(props.partReturn.account)}
                    label='DEALER_LOCATION'
                />
                <LabeledString
                    data={formatClaimNumber(props.partReturn.claimNumber)}
                    label='CLAIM'
                />
                <LabeledLink
                    data={props.partReturn.pin}
                    href={`#/products/${props.partReturn.pin}`}
                    label='PIN'
                />
                <LabeledString
                    data={props.partReturn.dtac}
                    label='DTAC_CASE'
                />
                <LabeledString
                    data={props.partReturn.reference1}
                    label='WORK_ORDER'
                />
                <LabeledString
                    data={buildDate(props.partReturn.requestDate)}
                    label='REQUESTED'
                />
                <LabeledString
                    data={buildPartReturnString(props.partReturn)}
                    label='PART'
                />
                <LabeledString
                    data={props.partReturn.returnStatus.description}
                    label='STATUS'
                />
                {props.partReturn.requestType.key === 'PART' &&
                    <div>
                        <LabeledString
                            data={props.partReturn.courierInfo.deereCourier}
                            label='COURIER_NAME'
                        />
                        <LabeledString
                            data={props.partReturn.courierInfo.courierAccountNumber}
                            label='COURIER_ACCOUNT_NUMBER'
                        />
                    </div>
                }
            </section>
        }
    </div>;

RequestInformationPanel.displayName = 'RequestInformationPanel';
RequestInformationPanel.propTypes = {
    partReturn: PropTypes.instanceOf(PartReturn).isRequired
};

export default RequestInformationPanel;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/request-information-panel.js